export default __webpack_public_path__ + "static/media/search-blue.7819628e.svg";